import { render, staticRenderFns } from "./FeetViewer.vue?vue&type=template&id=66b1a478&scoped=true&"
import script from "./FeetViewer.vue?vue&type=script&lang=js&"
export * from "./FeetViewer.vue?vue&type=script&lang=js&"
import style0 from "./FeetViewer.vue?vue&type=style&index=0&id=66b1a478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1a478",
  null
  
)

export default component.exports